import { render, staticRenderFns } from "./Gallerie.vue?vue&type=template&id=2f6ca16e&scoped=true&"
import script from "./Gallerie.vue?vue&type=script&lang=js&"
export * from "./Gallerie.vue?vue&type=script&lang=js&"
import style0 from "./Gallerie.vue?vue&type=style&index=0&id=2f6ca16e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_e0fc12eb4d0f55f4cb07c19882e21395/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6ca16e",
  null
  
)

export default component.exports